import {Component, OnInit} from '@angular/core';
import {CurriculumService} from '@app/services/curriculum.service';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';

interface Topic {
  id: number;
  ptTopicId: number;
  title: string;
  children: Topic[];
  show: boolean;
}

@Component({
  selector: 'app-curriculum',
  templateUrl: './curriculum.component.html',
  styleUrls: ['./curriculum.component.css']
})
export class CurriculumComponent implements OnInit {

  public topic: Topic;
  private classroom: ClassroomStateModel;

  constructor(
    private curriculumService: CurriculumService,
    private store: Store
  ) {
    this.listenStoreChanges();
    this.curriculumService.onDataLoad = (result: any) => {
      const topic = result.data as Topic;
      if (!topic) {
        return;
      }
      topic.children = this.clearEmptyTopics(topic.children);

      topic.children.sort((a: Topic, b: Topic) => {
        return a.title.localeCompare(b.title);
      });

      this.topic = topic;
    };
  }

  ngOnInit(): void {}

  public close(): void {
    this.curriculumService.close();
  }
  public get isOpen(): boolean {
    return this.curriculumService.isOpen;
  }
  public get isLoading(): boolean {
    return this.curriculumService.isLoading;
  }

  public openTopic(id: number, asImage = false): void {
    const vcPathInfo = encodeURIComponent(`/${this.classroom.roomNum}${this.classroom.vcrURL}/whiteboard/external?roomNum=${this.classroom.roomNum}`);

    const url = `${this.classroom.cmsURL}/viewtopic?asImg=${asImage}&vchostport=${location.host}&vcpathinfo=${vcPathInfo}&id=${id}&order=0&timestamp=${Date.now()}`;

    window.open(url, '_blank', 'height=800,width=800');
  }

  private clearEmptyTopics(topics: Topic[]): Topic[] {
    const filtered: Topic[] = [];
    topics.forEach(topic => {
      if (topic.title?.length > 0) {
        filtered.push(topic);
      }
      if (topic.children?.length > 0) {
        topic.children = this.clearEmptyTopics(topic.children);
      }
    });

    return filtered;
  }

  private listenStoreChanges(): void {
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
    });
  }
}
